import React from 'react';
import { StyledInput, StyledInputProps } from './StyledInput';

type Props = StyledInputProps & {
	value: number;
	onValueChange: (newValue: number) => void;
};

export const NumberInput: React.FC<Props> = (props) => {
	return <StyledInput type="number" placeholder="input" {...props} onChange={(_, d) => props.onValueChange(parseFloat(d.value))} />;
};
